import { components } from 'type/ReportServiceSchema';

export type InsightsQuestionDto = components['schemas']['QuestionDTO'];

export type InsightsQuestionModel = Readonly<{
  id: number;
  content: string;
}>;

export const mapInsightsQuestionDtoToModel = (dto: InsightsQuestionDto): InsightsQuestionModel => ({
  id: dto.id,
  content: dto.content,
});
